import React from 'react';
import LoadingIndicator from '../LoadingIndicator/LoadingIndicator';
import Translate from '../Translate/Translate';
import classnames from '../../helpers/classnames';

type Props = React.ComponentProps<'div'>;

export default function NowLoadingMessage(props: {
    message?: string,
    display?: boolean,
    justifyContent?: 'center' | 'start' | 'end',
    paddingY?: 0 | 1 | 2 | 3 | 4 | 5,
    paddingX?: 0 | 1 | 2 | 3 | 4 | 5,
} & Pick<Props, keyof Props>) {
    const {
        className,
        message = '@common-phrases.loading',
        display = true,
        justifyContent = 'center',
        paddingY = 5,
        paddingX = 2,
        ...rest
    } = props;

    if (!display) {
        return null;
    }

    return <div {...rest} className={classnames(className, [
        `d-flex justify-content-${justifyContent} align-items-center py-${paddingY} px-${paddingX}`
    ])}>
        <LoadingIndicator type="border" size="sm"/>
        <Translate message={message} className="ms-2"/>
    </div>;
}
